import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';
import { TodoComponent } from '../todo/todo.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-dashboard',
  imports: [ToolbarComponent, TodoComponent, FooterComponent, MatProgressSpinnerModule],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  showLoading = false;
  onLoadingEvent(event: boolean) {
    this.showLoading = event;
  }
}
